import isNumber from 'lodash/isNumber';

export const numerize = str => {
  if (isNumber(str)) return;
  return str && str.replace(/[^0-9]/g, '');
};
